<app-brand-header [maxBrandColumns]="MAX_BRAND_COLUMNS"></app-brand-header>
<div class="marketing-report-content">
  @if (isThemesGrouping ? messagingData?.categories : messagingGroupingData?.categories) {
  @for (category of (isThemesGrouping ? messagingData!.categories : messagingGroupingData!.categories); track category.name; let last = $last) {
  @if (last && isThemesGrouping) {
  <app-messaging-category-table [data]="category" [maxBrandColumns]="MAX_BRAND_COLUMNS" appInfiniteScroll
    (scrolled)="onLoadMore()">
  </app-messaging-category-table>
  } @else {
  <app-messaging-category-table [data]="category" [maxBrandColumns]="MAX_BRAND_COLUMNS" [groupingType]="groupingType">
  </app-messaging-category-table>
  }
  }
  }
</div>
@if (isLoading) {
<div class="loading-spinner">
  <app-spinner-icon></app-spinner-icon>
</div>
}

@if (!(isThemesGrouping ? messagingData?.categories?.length : messagingGroupingData?.categories?.length) && !isLoading) {
<div class="no-data-container">
  <img [src]="'svg/no-data-no-text.svg' | assetVersion" alt="No data" class="no-data-image">
  <div class="no-data-text">
    <span class="main-text">No Messaging Insights Available</span>
    <span class="sub-text">Try adjusting brands or filters </span>
    <span class="sub-text">to explore available messaging.</span>
  </div>
</div>
}